import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Container } from '@scentregroup/ui'
import classNames from 'classnames'
import containerStyle from '../container.scss'
import ResponsiveImage from '../responsive-image'
import Trackable from '../trackable'
import { trackingActions, trackingTypes } from '../../constants'
import style from './index.scss'

const FlipFlop = ({
  children,
  imageUrl,
  position,
  size,
  link,
  lazyLoad,
  className,
  analyticsMetadata,
}) => {
  const image = (
    <ResponsiveImage
      lazyLoad={lazyLoad}
      className={style.image}
      desktopImageUrl={imageUrl}
      mobileImageUrl={imageUrl}
      mobileRatio="standard"
      desktopRatio="standard"
      numberOfItems={2}
      alt=""
    />
  )

  return (
    <Trackable
      trackingAction={trackingActions.viewPromotion}
      type={trackingTypes.promotion}
      {...analyticsMetadata}
    >
      <Container
        type={size}
        className={classNames(
          containerStyle.container,
          style.FlipFlop,
          style[position],
          className
        )}
      >
        {link ? <Link to={link}>{image}</Link> : image}
        {children}
      </Container>
    </Trackable>
  )
}

FlipFlop.propTypes = {
  children: PropTypes.node.isRequired,
  link: PropTypes.string,
  imageUrl: PropTypes.string,
  position: PropTypes.oneOf(['left', 'right']),
  size: PropTypes.string,
  lazyLoad: PropTypes.bool,
  className: PropTypes.string,
  analyticsMetadata: PropTypes.shape({
    correlationId: PropTypes.string,
    title: PropTypes.string,
    promotion: PropTypes.shape({
      creative: PropTypes.string,
    }),
  }),
}

FlipFlop.defaultProps = {
  lazyLoad: true,
}

export default FlipFlop
